import React, { forwardRef, useMemo } from 'react'
import { FieldTypes, urlRegexValidator, emailValidator } from 'utils/formUtils';
import MendMappingForm from './MendMappingForm';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import { useFeatureFlag } from "contexts/FeatureFlagContext";
import { Alert } from 'antd';

function MendCredentialsForm(props, ref) {
    const featureFlags = useFeatureFlag();
    const fields = useMemo(() => (
    [{
        name: "apiEndpoint",
        label: "API Endpoint",
        rules: [urlRegexValidator]
    },
        {
        name: "userKey",
        label: "User Key",
        type: FieldTypes.PASSWORD,
        required: true
    },{
        name: "orgToken",
        label: "Org Token",
        type: FieldTypes.PASSWORD,
        required: true
    },{
        name: "email",
        label: "Email",
        rules: [emailValidator],
        required: true
    },{
        name: "message",
        type: FieldTypes.LABEL,
        value: <Alert type='warning' message="Projects for this integration will be available after few minutes of adding the credentials, since they are pulled in background."/>
    }, ...(featureFlags.MANAGE_SBOM ? [{
        name: "ingestSBOM",
        label: "Ingest Components",
        type: FieldTypes.SWITCH,
        help: 'Ingest SBOM and components from the tool projects mapped under this configuration into the supply chain module',
        inline: true,
    }] : [])]
    ),[featureFlags.MANAGE_SBOM])

    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            initialValue={{apiEndpoint:"https://saas.whitesourcesoftware.com/api/v1.4", ingestSBOM: 
                featureFlags.MANAGE_SBOM ? false : undefined}}
            config={ props.config && { apiEndpoint:"https://saas.whitesourcesoftware.com/api/v1.4", ...props.config }}
            MappingForm={MendMappingForm}
        />
    )
}

export default forwardRef(MendCredentialsForm);